"use client";

import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
} from "@/components/ui/command";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { MdKeyboardArrowDown } from "react-icons/md";

interface TypeScreeningCombox {
    style?: string;
    styleContent?: string;
    placehoder: string;
    selectedItem: number | null;
    onSelect: (id: number | null) => void;
    data: {
        id: number;
        name?: string;
        title?: string;
    }[];
}

export default function ScreeningComBox(props: TypeScreeningCombox) {
    const { style, styleContent, placehoder, data, selectedItem, onSelect } =
        props;

    const [open, setOpen] = React.useState(false);

    const handleSelect = (currentValue: number | null) => {
        if (selectedItem === currentValue) {
            onSelect(null);
        } else {
            onSelect(currentValue);
        }
        setOpen(false);
    };

    const getItemLabel = (item: { name?: string; title?: string }) => {
        return item.name || item.title || "";
    };

    return (
        data &&
        data?.length > 0 && (
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        role="combobox"
                        aria-expanded={open}
                        className={cn(
                            "hover:bg-gray-100 border-[#00715D] flex justify-between disabled:bg-gray-100 py-1 disabled:hover:text-black px-2 rounded-lg",
                            style
                        )}
                    >
                        {selectedItem
                            ? getItemLabel(
                                  data.find((d) => d.id === selectedItem) || {}
                              )
                            : placehoder}
                        <MdKeyboardArrowDown
                            className={cn(
                                open && "rotate-180",
                                "ml-2 h-4 w-4 shrink-0 opacity-50 duration-150"
                            )}
                        />
                    </Button>
                </PopoverTrigger>
                <PopoverContent dir="ltr" className={cn("p-0", styleContent)}>
                    <Command>
                        <CommandInput dir="rtl" placeholder={placehoder} />
                        <CommandEmpty>موردی یافت نشد !</CommandEmpty>
                        <CommandList>
                            <CommandGroup>
                                {data.map((item) => (
                                    <CommandItem
                                        key={item.id}
                                        onSelect={() => handleSelect(item.id)}
                                        className="my-1 cursor-pointer "
                                        aria-selected={selectedItem === item.id}
                                        dir="rtl"
                                    >
                                        <span className="">
                                            {item.name} {item?.title}
                                        </span>
                                        <Check
                                            className={cn(
                                                "mr-4 h-4 w-4",
                                                selectedItem === item.id
                                                    ? "opacity-100"
                                                    : "opacity-0"
                                            )}
                                        />
                                    </CommandItem>
                                ))}
                            </CommandGroup>
                        </CommandList>
                    </Command>
                </PopoverContent>
            </Popover>
        )
    );
}
